module.exports = __webpack_public_path__ + "static/media/29ADMSPC33.710b5f2d.jpg";